import apiClient from './api';

// 短信渠道
export interface SmsChannel {
  id: string;
  name: string;
  code: string;
  provider: string;
  accessKey: string;
  secretKey: string;
  signName: string;
  endpoint: string;
  region: string;
  appId: string;
  isDefault: number;
  status: number;
  remark: string;
  createdAt: string;
  updatedAt: string;
}

// 短信模板
export interface SmsTemplate {
  id: string;
  channelId: string;
  name: string;
  code: string;
  templateId: string;
  templateType: string;
  content: string;
  params: string;
  status: number;
  remark: string;
  createdAt: string;
  updatedAt: string;
  channel?: SmsChannel;
}

// 短信日志
export interface SmsLog {
  id: string;
  channelId: string;
  channelName: string;
  templateId: string;
  templateName: string;
  templateCode: string;
  phone: string;
  content: string;
  params: string;
  sendStatus: number;
  resultCode: string;
  resultMsg: string;
  bizId: string;
  sendTime: string;
  receiveTime: string;
  userId: string;
  ip: string;
  createdAt: string;
}

// 服务商选项
export const providerOptions = [
  { value: 'tencent', label: '腾讯云' },
];

// 模板类型选项
export const templateTypeOptions = [
  { value: 'verify', label: '验证码' },
  { value: 'notify', label: '通知' },
  { value: 'marketing', label: '营销' },
];

// 模板编码选项
export const templateCodeOptions = [
  { value: 'staff_accept_order_notice', label: '服务人员接单通知' },
  { value: 'dispatch_order_accepted_notice', label: '派单已接单通知' },
  { value: 'staff_checkin_notice', label: '服务人员签到通知' },
  { value: 'staff_order_completed_notice', label: '服务人员已完成通知' },
  { value: 'user_refund_arrived_notice', label: '用户退款到账通知' },
  { value: 'staff_withdraw_notice', label: '服务人员提现通知' },
  { value: 'deposit_review_approved_notice', label: '保证金审核通过通知' },
  { value: 'certification_approved_notice', label: '认证通过通知' },
];

// 发送状态选项
export const sendStatusOptions = [
  { value: 0, label: '待发送', color: 'default' },
  { value: 1, label: '发送中', color: 'processing' },
  { value: 2, label: '成功', color: 'success' },
  { value: 3, label: '失败', color: 'error' },
];

// 渠道API
export const listChannels = (params?: any) =>
  apiClient.get('/sms/channels', { params });

export const getAllChannels = () =>
  apiClient.get('/sms/channels/all');

export const getChannel = (id: string) =>
  apiClient.get(`/sms/channels/${id}`);

export const createChannel = (data: Partial<SmsChannel>) =>
  apiClient.post('/sms/channels', data);

export const updateChannel = (id: string, data: Partial<SmsChannel>) =>
  apiClient.put(`/sms/channels/${id}`, data);

export const deleteChannel = (id: string) =>
  apiClient.delete(`/sms/channels/${id}`);

// 模板API
export const listTemplates = (params?: any) =>
  apiClient.get('/sms/templates', { params });

export const getTemplate = (id: string) =>
  apiClient.get(`/sms/templates/${id}`);

export const createTemplate = (data: Partial<SmsTemplate>) =>
  apiClient.post('/sms/templates', data);

export const updateTemplate = (id: string, data: Partial<SmsTemplate>) =>
  apiClient.put(`/sms/templates/${id}`, data);

export const deleteTemplate = (id: string) =>
  apiClient.delete(`/sms/templates/${id}`);

// 日志API
export const listLogs = (params?: any) =>
  apiClient.get('/sms/logs', { params });

export const getLog = (id: string) =>
  apiClient.get(`/sms/logs/${id}`);

export const getStats = () =>
  apiClient.get('/sms/logs/stats');
